import { Locale } from '../../dashboard/enums/locale.enum';

export interface DateLocationContent {
  monthLocale: string;
}

type DateLocationContents = { [P in Locale]: DateLocationContent };

export const dateLocationContents: DateLocationContents = {
  [Locale.English]: {
    monthLocale: 'en-us',
  },
  [Locale.Korean]: {
    monthLocale: 'ko-KR',
  },
};



// WEBPACK FOOTER //
// ./src/app/assets/contents/date-location.content.ts